import React, { Component } from 'react';
import Navbar from './Navbar';
import Slider from './Slider';
import Timeline from './Timeline';
import Certificates from './Certificates';
import About from './About';
import Offers from './Offers';
import News from './News';
import Contact from './Contact';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import './WorkPage.css';

const WorkPage = props => (

		<section className="container work-section" id="work">    
      {/*<div className="project-about" id="about">
            <img className="loga-about" src="loga_gotowe.jpg" alt="loga" />
            <p>
               Projekt polega na praktycznym wdrożeniu nowej technologii w postaci wyników prac B+R drogą inwestycji technologicznej
               polegającej na uruchomieniu produkcji opakowań ekologicznych dla rynku fresh food.
            </p>
            <p>
               Celem przedsięwzięcia jest trwała poprawa konkurencyjności przedsiębiorstwa HADEPOL FLEXO Sp. z o.o. na krajowym
               i zagranicznym rynku opakowań poprzez wdrożenie innowacji technologicznych w obszarze wytwarzania opakowań papierowych powlekanych.
               Efektem realizacji projektu będzie wdrożenie innowacji procesowej nie znanej do tej pory na świecie oraz zupełnie nowego produktu
               o nieznanym dotąd poziomie użytkowym. Zakres rzeczowy projektu obejmuje nakłady inwestycyjne związane
               z zakupem następujących nowych środków trwałych:
               1. Linia technologiczna do produkcji opakowań.
            </p>
            <p>
               Projekt pozwoli znacząco poszerzyć ofertę produktową i technologiczną przedsiębiorstwa, co zostanie osiągnięte drogą
               praktycznego zastosowania innowacyjnych rozwiązań w zakresie produkcji opakowań papierowych o unikalnej konstrukcji
               i podwyższonych walorach użytkowych.Projekt polega na praktycznym wdrożeniu nowej technologii w postaci wyników prac B+R drogą
               inwestycji technologicznej polegającej na uruchomieniu produkcji opakowań ekologicznych dla rynku fresh food."
            </p>
            <p>
               Wartość projektu : 10 380 499,20 PLN<br />
               Wkład Funduszy Europejskich : 4 671 224,66 PLN
            </p>
          </div>*/}
			<Row>
				<Col className="center title">
					<h2>Praca</h2>
				</Col>
			</Row>
         {/**<h3>Poszukujemy pracownika na stanowisko:
         <span className="bold">Asystenka Biura Zarządu</span></h3>
         <h4>Zadania na stanowisku:</h4>
         <ul>
         	<li>bieżąca obsługa sekretariatu</li>
         	<li>rejestracja korespondencji wychodzącej oraz przychodzącej (tradycyjnej, elektronicznej)</li>
         	<li>codzienne wsparcie Zarządu w zakresie zadań administracyjno-organizacyjnych</li>
         	<li>zarządzanie obiegiem dokumentów</li>
         	<li>organizacja spotkań oraz obsługa gości firmy</li>
         	<li>segregacja i archiwizacja dokumentów</li>
         	<li>prowadzenie kalendarza spotkań</li>
         	<li>zapewnienie prawidłowego przepływu informacji pomiędzy Zarządem firmy, a innymi komórkami organizacyjnymi w firmie</li>
         	<li>podejmowanie gości i dbałość o estetykę biura</li>
         	<li>dbanie o dobry wizerunek firmy</li>
         	<li>odpowiedzialność za sprawne funkcjonowania biura</li>
         </ul>
         <h4>Wymagania:</h4>
         <ul>
         	<li>mile widziane wykształcenie wyższe</li>
         	<li>prawo jazdy kat. B</li>
         	<li>dobra znajomość pakietu MS Office</li>
         	<li>mile widziane doświadczenie na podobnym stanowisku</li>
         	<li>bardzo dobra organizacja pracy własnej</li>
         	<li>umiejętność analitycznego myślenia i efektywnego rozwiązywania problemów</li>
         	<li>samodzielność i inicjatywa</li>
         	<li>komunikatywność, sumienność, dokładność, terminowość</li>
         	<li>wysoka kultura osobista</li>
         	<li>znajomość języka angielskiego w poziomie co najmniej komunikatywnym</li>
         </ul>
         <h4>Oferujemy:</h4>
         <ul>
         	<li>współpracę z firmą o ugruntowanej pozycji na rynku</li>
         	<li>wsparcie oraz profesjonalne wprowadzenie na stanowisko</li>
         	<li>niezbędne narzędzia do wykonywania zadań</li>
         	<li>stabilne zatrudnienie w formie umowy o pracę</li>
         </ul>
         <i>Prosimy o zawarcie w CV klauzuli: „Wyrażam zgodę na przetwarzanie moich danych osobowych zawartych w dokumentach aplikacyjnych przekazanych przeze mnie oraz zebranych w trakcie ewentualnych rozmów kwalifikacyjnych , w celu udziału w wybranej rekrutacji prowadzonej przez Hadepol Flexo Sp. z o.o.,”</i>**/}
        

        <h3>Poszukujemy pracowników na stanowiska:</h3>
        <h3 className="offer_work">
         <a href="https://www.olx.pl/533323446/?bs=olx_pro_listing" target="_blank" className="bold">Operator maszyny produkcyjnej</a>
        </h3><br />
        <h3 className="offer_work">
         <a href="https://www.olx.pl/oferta/praca/zatrudnie-elektronika-mechatronika-do-dzialu-przygotowania-produkcji-CID4-IDLxeBD.html?bs=olx_pro_listing" target="_blank" className="bold">Elektronik - mechatronik do działu przygotowania produkcji</a>
        </h3><br />
        {/*<h3 className="offer_work bold">
         Pakowaczki do działu produkcyjnego
        </h3><br />
         <p className="center">CV prosimy składać w sekretariacie firmy przy ul. Polnej 2 w Rypinie.</p><br />*/}
         <i>Prosimy o zawarcie w CV klauzuli: „Wyrażam zgodę na przetwarzanie moich danych osobowych zawartych w dokumentach aplikacyjnych przekazanych przeze mnie oraz zebranych w trakcie ewentualnych rozmów kwalifikacyjnych , w celu udziału w wybranej rekrutacji prowadzonej przez Hadepol Flexo Sp. z o.o.,”</i>
         {/*<h3>Brak ogłoszeń</h3>*/}
        </section>
	);

export default WorkPage;